.container {
  align-items: center;
  width: 100%;
}

.selectedWrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.janePayLogo {
  margin-top: 4px;
  margin-left: 16px;
  margin-right: auto;
}

.poweredByMobile {
  display: flex;
  margin-left: 16px;
  margin-right: auto;
  margin-top: -4px;
}

.poweredByDesktop {
  display: none;
}

.janeLogo {
  display: inline-flex;
}

@media (--reefer-media-tablet-min) {
  .selectedWrapper {
    flex-direction: row;
    align-items: center;
  }

  .janePayLogo {
    margin-top: 0;
    margin-left: auto;
    margin-right: 16px;
  }

  .poweredByMobile {
    display: none;
  }

  .poweredByDesktop {
    display: flex;
    margin-top: 0;
    margin-left: auto;
    margin-right: 16px;
  }
}
